import React from 'react';
import { Button, UncontrolledTooltip } from 'reactstrap';
import { Icon } from "./Icon";

export function Accion({ id, className, action, icon, tooltip }) {

  return <span id={ id }>
    <Button className={className} onClick={ action }>
      {<Icon icon={icon} />}
    </Button>
    <UncontrolledTooltip placement="top" target={ id }>
      {tooltip}
    </UncontrolledTooltip>
  </span>
}